import React from 'react'
import TopImage from './Caminho_979.svg'

export const HeaderResult = ({ text, myNote, avg }: Props) => {
    return (
        <div className='flex justify-center  bg-no-repeat  mb-10'>
            <div className="text-center w-full h-auto" style={{
                backgroundImage: 'url("' + TopImage + '")',
                backgroundRepeat: "no-repeat",
                backgroundSize: "auto auto",
                backgroundPosition: "center"
            }}>
                <div className='min-w-full grid grid-cols-6'>
                    <div className='py-7 px-0 text-left col-span-4 col-start-2' style={{ fontSize: 18 }}>
                        Que legal, você concluiu o bloco de <strong>{text}</strong> <br />
                        Com base nas suas respostas a sua nota é <strong>{myNote}</strong>.
                        A média de outras organizações nesta categoria é <strong>{avg}</strong>.
                    </div>
                </div>

            </div>
        </div>
    )
}

interface Props {
    text: string,
    myNote: string
    avg: string

}